import { Box } from "@mui/material";
import OurTeamComponent from "../../components/OurTeamComponent/OurTeamComponent";
import DashboardLayout from "../../Layout/DashboardLayout/DashboardLayout";
import { Helmet } from "react-helmet";
import TagManager from "react-gtm-module";
import { useEffect } from "react";

const OurTeam = () => {
  useEffect(() => {
    const tagManagerArgs = {
      gtmId: "G-VWGPB9LR1K", // Replace with your Google Tag Manager ID
      dataLayerName: "PageDataLayer",
      dataLayer: {
        page: window.location.pathname,
      },
    };
    TagManager.initialize(tagManagerArgs);
  }, []);
  return (
    <>
      <Helmet>
        <title>
          Marcel Equipment Team | Construction & Landfill Specialists
        </title>
        <link rel="icon" href="/favicon.ico" type="image/x-icon" />
        <meta
          name="description"
          content="Meet the team at Marcel Equipment, experts in used, rebuilt, and reconditioned heavy equipment who’re committed to delivering exceptional service and support."
        />
      </Helmet>
      <DashboardLayout activeTab={"OurTeam"}>
        <OurTeamComponent />
      </DashboardLayout>
    </>
  );
};
export default OurTeam;
